(function() {
    'use strict';
    angular
        .module('tmgApp')
        .factory('Conges', Conges);

    Conges.$inject = ['$resource', 'DateUtils'];

    function Conges ($resource, DateUtils) {
        var resourceUrl =  'api/conges/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                        data.dateEnd = DateUtils.convertLocalDateFromServer(data.dateEnd);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    copy.dateEnd = DateUtils.convertLocalDateToServer(copy.dateEnd);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    copy.dateEnd = DateUtils.convertLocalDateToServer(copy.dateEnd);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
